var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4079 23.3996H6.2079C4.77196 23.3995 3.6079 22.2355 3.60791 20.7995L3.60801 5.19959C3.60802 3.76366 4.77208 2.59961 6.20801 2.59961H17.9083C19.3442 2.59961 20.5083 3.76367 20.5083 5.19961V12.3496M15.3083 19.7163L17.6917 22.0996L22.8917 16.8994M8.15832 7.79961H15.9583M8.15832 11.6996H15.9583M8.15832 15.5996H12.0583",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileCheck);
export default __webpack_public_path__ + "static/media/icon-file-check.6edf85d91217f9325f14d68e5f5bd6f8.svg";
export { ForwardRef as ReactComponent };